/**
 * Bosh sahifa: rolga qarab uch ko'rinish (redesign v2) -- recruiter "Bugun", menejer va team lead "Bugun + Jamoa",
 * owner "Kompaniya pulsi". Hamma raqam backend'da status tarixidan hisoblanadi (apps/dashboards); bu yerda faqat chiziladi.
 * Davr URL'da (?period=YYYY-MM), filial doirasi -- app/branchFilter (ScopePicker).
 */
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import { scopedBranch, useBranchFilter } from "@/app/branchFilter";
import { useMe } from "@/features/auth/hooks";
import { currentPeriod, useDashboard } from "@/features/dashboards/api";
import { ErrorState } from "@/components/ui/misc";
import { OwnerHome } from "./OwnerHome";
import { ManagerHome } from "./ManagerHome";
import { RecruiterHome } from "./RecruiterHome";

export function HomePage() {
  const { t } = useTranslation("home");
  const me = useMe();
  const [params, setParams] = useSearchParams();
  const { branchId } = useBranchFilter();
  const period = params.get("period") ?? currentPeriod();
  const dash = useDashboard({ period, branch: scopedBranch(me.data, branchId) });

  if (!me.data || (dash.isPending && !dash.data)) return <HomeSkeleton />;
  if (dash.isError || !dash.data) return <ErrorState message={dash.error?.message ?? t("loadError")} onRetry={() => dash.refetch()} />;

  const setPeriod = (value: string) =>
    setParams((p) => {
      const next = new URLSearchParams(p);
      if (value === currentPeriod()) next.delete("period");
      else next.set("period", value);
      return next;
    });

  const props = { me: me.data, data: dash.data, period, setPeriod };
  switch (me.data.role) {
    case "owner":
      return <OwnerHome {...props} />;
    case "branch_manager":
      return <ManagerHome {...props} />;
    default:
      return <RecruiterHome {...props} />;
  }
}

/** Yuklanish: sahifa shakli darhol ko'rinadi (aylanuvchi emas) */
function HomeSkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true">
      <div className="space-y-3">
        <div className="skeleton h-3 w-72 rounded-full" />
        <div className="skeleton h-10 w-96 max-w-full rounded-xl" />
        <div className="skeleton h-4 w-[480px] max-w-full rounded-full" />
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(230px,100%),1fr))] gap-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="skeleton h-[136px] rounded-card" />
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        <div className="skeleton h-[360px] rounded-card xl:col-span-2" />
        <div className="skeleton h-[360px] rounded-card" />
      </div>
    </div>
  );
}
